import React, { ReactElement } from "react";
import ModalPopUp from './ModalPopUp';
import Button from '../Buttons/Button';

 interface MessagePopUpProps {
    message: ReactElement,
    showPopUpMessage : any,
    buttonText: string,
    classNameStyle: string,
    classNameStyleButton?: string
}

const MessagePopUp: React.FC<MessagePopUpProps> = (props: MessagePopUpProps) => {

    const closePopUpSuccessful = async () => {
        props.showPopUpMessage();
    }

    return (
        <ModalPopUp classNameStyle={props.classNameStyle}>
            <div className="row justify-content-center">
                <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12" >
                    {props.message}
                </div>
                <Button
                    id="btnAccept"
                    onClick={closePopUpSuccessful}
                    styleClass={props.classNameStyleButton + " mt-2"}
                    textoButton={props.buttonText}
                />
            </div>
        </ModalPopUp>
    );
};

export default MessagePopUp;